<style>
.teamsport-table .v-data-table__wrapper table {
    border-collapse: collapse;
}
</style>

<template>
    <div v-if="loading && !table" class="d-flex align-center justify-center">
        <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
    </div>
    <div v-else-if="error">
        <v-alert type="error">
            <span v-if="error">{{ $translate('Error loading table') }}</span>
        </v-alert>
    </div>
    <div v-else-if="table">
        <v-data-table
            :headers="tableHeaders"
            :items="tableRows"
            class="teamsport-table elevation-1"
            :items-per-page="table.tableLimit || -1"
            :hide-default-footer="!table.tableLimit || tableRows.length <= table.tableLimit"
            :hide-default-header="!table.header"
            :mobile-breakpoint="0"
            :disable-sort="true"
            :style="tableStyle"
        >
            <template v-slot:item="{ item }">
                <tr :style="rowStyle(item)">
                    <td v-for="(header, index) in tableHeaders" :key="index" :style="cellStyle(header)">
                        <div v-if="header.column.format === 'image'" class="d-flex align-center">
                            <template v-if="header.column.text">
                                <img v-if="item[header.value][0]" :src="getTeamLogo(header.column.imagetype, item[header.value][0], header.column.imagesize)" :height="header.column.imagesize || 30" class="mr-2">
                                <span v-if="header.column.text">{{ item[header.value][1] }}</span>
                            </template>
                            <template v-else>
                                <img v-if="item[header.value]" :src="getTeamLogo(header.column.imagetype, item[header.value], header.column.imagesize)" :height="header.column.imagesize || 30" class="mr-2">
                            </template>
                        </div>
                        <div v-else style="text-align: right" v-html="item[header.value]" />
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    name: 'zoezi-teamsport-table',

    zoezi: {
        title: 'Table for division',
        icon: 'mdi-table-large',
        addon: 'TeamSports'
    },

    props: {
        divisionId: {
            title: 'Division ID',
            type: Number
        }
    },

    watch: {
        divisionId: {
            immediate: true,
            handler() {
                this.loadTable();
            }
        }
    },

    data: () => ({
        loading: false,
        error: false,
        table: null,
        unsubscribe: [],
        tableRows: [],
        tablelinetype: [
            {id: 'none', name: 'None'},
            {id: 'thin', name: 'Thin', css: '2px solid'},
            {id: 'dashed', name: 'Dashed', css: '2px dashed'},
            {id: 'thick', name: 'Thick', css: '4px solid'}
        ]
    }),

    computed: {
        mobile() {
            return this.$vuetify.breakpoint.mobile
        },
        tableStyle() {
            return {
                'background-color': this.table.background_color,
                'color': this.table.text_color
            }
        },
        tableHeaders() {
            return this.table.columns.filter(col => col.mobile || !this.mobile).map(col => ({
                text: this.mobile ? col.shortname : col.name,
                value: col.name,
                align: col.format == 'image' ? 'start' : 'end',
                column: col
            }));
        }
    },

    methods: {
        initializeTable() {
            this.tableRows = this.table.rows.map(row => {
                let rowData = {};
                this.tableHeaders.forEach((header, index) => {
                    rowData[header.value] = row[index];
                });
                return rowData;
            });
        },
        loadTable() {
            this.loading = true;
            this.$api.get('/api/memberapi/teamsport/result/for_division', {division_id: this.divisionId}).then(table => {
                this.table = table;
                this.initializeTable();
                this.loading = false;
            }).catch(() => {
                this.loading = false;
                this.error = true;
            });
        },
        getTeamLogo(imagetype, id, size) {
            if (!size) {
                size = 30;
            }
            return `/api/public/image/get?type=${imagetype}&id=${id}&size=${size}x${size}`;
        },
        cellStyle(header) {
            if (header.column.background_color || header.column.text_color || header.column.bold != undefined) {
                return {
                    'background-color': header.column.background_color,
                    'color': header.column.text_color,
                    'font-weight': header.column.bold ? 'bold' : 'normal'
                }
            }
        },
        rowStyle(item) {
            const rownr = this.tableRows.indexOf(item) + 1;
            if (!rownr || !this.table.lines) {
                return;
            }

            let line;
            this.table.lines.filter(d => !d.from_bottom).forEach(d => {
                if (rownr > d.position) {
                    line = d;
                }
            });
            this.table.lines.filter(d => d.from_bottom).forEach(d => {
                if (rownr > this.table.rows.length - d.position) {
                    line = d;
                }
            });

            if (line) {
                let res = {};

                if ( (!line.from_bottom && rownr == line.position + 1) || (line.from_bottom && rownr == this.table.rows.length - line.position + 1)) {
                    let lt = this.tablelinetype.find(x => x.id == line.type);
                    let css = lt && lt.css;
                    if (css) {
                        res['border-top'] = css;
                    }
                }
                if (line.text_color) {
                    res.color = line.text_color;
                }
                if (line.background_color) {
                    res['background-color'] = line.background_color;
                }
                return res;
            }
        }
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    },
    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsporttable',  callback: () => {
            this.loadTable();
        }}));
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportdivision',  callback: (_, event) => {
            if (event.data.find(x => x.id == this.divisionId)) {
                this.loadTable();
            }
        }}));
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportmatch',  callback: (_, event) => {
            if (event.data.find(x => x.division_id == this.divisionId)) {
                this.loadTable();
            }
        }}));
    }
}
</script>
